import React from 'react';

import styles from './styles.module.css';
import noSitesIcon from '../../assets/icons/no-sites-sssigned.png';

interface EmptyStateProps {
  title: string;
  subtitle: string;
  icon?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  subtitle,
  icon = true
}) => {
  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.content}>
        {icon && (
          <img
            src={noSitesIcon}
            alt="Empty state icon"
            className={styles.icon}
          />
        )}
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};

export default EmptyState;
